import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "CardApp",
  components: {},
  props: ["w", "h"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      col: 8
    };
  },
  computed: _objectSpread({
    pageSize: function pageSize() {
      return this.w * 3 * (this.h * 2);
    }
  }, mapGetters(["userToken"])),
  created: function created() {
    this.fetchList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/app/appPermitList", this.$qs.stringify({
        pageNum: 1,
        pageSize: this.pageSize
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;

          _this.$nextTick(function () {
            _this.computeCol();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    //  aws=aws应用，tokenUrl=单点a标签带token跳转，resultUrl = 返回url再进行跳转
    jumpTo: function jumpTo(item) {
      var url = item.appUrl;

      if (item.appType === "aws") {
        // aws应用
        url = url + "?sid=" + this.userToken;
        window.open(url);
      } else if (item.appType === "tokenUrl") {
        // 外部应用
        var authorize = window.sessionStorage.getItem("authorization");
        url = url + "?".concat(item.appTokenName, "=") + authorize.split(" ")[1];
        window.open(url);
      } else if (item.appType === "resultUrl") {
        // 返回url跳转
        this.getResulUrl(url);
      } else {
        // 自己的应用
        window.open(url);
      }

      this.serverInsert(item);
    },
    getResulUrl: function getResulUrl(url) {
      var token = window.sessionStorage.getItem("authorization");
      this.$http.get(url, {
        headers: {
          Authorization: "Basic bmVpemhlbjpuZWl6aGVu",
          token: token
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode === 0) {
          var _url = data.resData;
          window.open(_url);
        }
      }).catch();
    },
    //访问统计计数器
    serverInsert: function serverInsert(item) {
      this.$http.post("/statistical/serverInsert", this.$qs.stringify({
        serviceId: item.id,
        appType: 9
      })).then(function () {}).catch(function () {});
    },
    // 每次获取计算列个数
    computeCol: function computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;

        case 2:
          this.col = 4;
          break;

        case 3:
          this.col = 3;
          break;

        default:
          break;
      }
    },
    resizedEvent: function resizedEvent() {
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};